
import { Component, Vue, } from 'vue-property-decorator';
import { Store, } from '~/apps/meter-read/store';
import HeaderText from '~/components/header-text/header-text.vue';
import LandingLink from '~/components/landing-link/landing-link.vue';
import Checklist from '~/components/self-serve/checklist/checklist.vue';
import LandingSection from '~/components/self-serve/landing-section/landing-section.vue';
import { CHECKLIST_ITEMS, } from '~/utils/self-serve-checklist-items';

const ChecklistItems = [
	CHECKLIST_ITEMS.customerNumber,
	CHECKLIST_ITEMS.paymentReference,
	CHECKLIST_ITEMS.lastNameOnBill,
	CHECKLIST_ITEMS.meterReading,
];

@Component({
	components: {
		HeaderText,
		LandingLink,
		LandingSection,
		Checklist,
	},
})
export default class MeterReadLandingPage extends Vue {
	mounted() {
		Store.commit.reset();
		Store.commit.setStep(null);
	}

	troubleFindingMeterLocation = Store.getters.getGlobalConfigValue('TroubleFindingMeterLocation');
	tellUsYouAreMovingLocation = Store.getters.getGlobalConfigValue('TellUsYouAreMovingLocation');
	checklistItems = ChecklistItems;
}
